var myProductSizeChart = myProductSizeChart || {};

myProductSizeChart.run = (function() {
    var currentType = 1; //当前类型 1cm 0英寸
    var domId = '#product-metafield-size';
    //变量
    var productTitle = my_product_size_chart_title;
    var sizeList = my_product_size_chart_table;
    var detail = my_product_size_chart_detail;
    var siteLabel = '';
    if (typeof my_product_size_chart_site_label !== 'undefined') {
        siteLabel = my_product_size_chart_site_label;
    }
    var currentCountry = '';

    function loadDom(element){
        if(siteLabel == 'MT'){
            //把#product-size-chart-open-container 元素内容移到.size-chart-right后
            const oldEle = document.getElementsByClassName('product-size-chart-open-container-class');
            try{
                if(oldEle){
                    oldEle.forEach(function(ele){
                        ele.remove();
                    });
                }
            }catch (error){
            }

            const container = document.getElementById('product-size-chart-open-container');
            if (container) {
                //添加class类
                container.classList.add('product-size-chart-open-container-class');
                element.appendChild(container);
            }
        }
    }

    // 初始化监听器
    function initObserver() {
        if(siteLabel == 'MT'){
            //监听.size-chart-right加载完成
            const mutationObserver = new MutationObserver((mutations) => {
                const element = document.querySelector('.size-chart-right');
                if (element) {
                    loadDom(element);
                    // 一旦找到元素并执行了 loadDom，就可以停止观察
                    mutationObserver.disconnect();
                }
            });

            // 开始观察整个文档的变化
            mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        }

        //监听.size-chart-right加载完成
        //会有问题，切换尺码后第三方插件的尺码会消失
        const repeatObserver = new MutationObserver((mutations) => {
            if(document.querySelector('.ks-chart-container')){
                //隐藏size_chart
                document.querySelector('#product-size-chart-open-container').style.display = 'none';
            }else{
                document.querySelector('#product-size-chart-open-container').style.display = 'block';
            }
        });

        // 开始观察整个文档的变化
        repeatObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // 立即初始化观察者
    initObserver();

    var openLock = false;

    function sizeOpen(){
        if(openLock){
            return false;
        }
        openLock = true;
        let scrollTop = getScrollTop();

        document.querySelector(domId).style.display = 'block';
        document.documentElement.classList.add('my-kiwi-sizing-modal-visible', 'vanilla-modal');
        document.body.classList.add('fixed-on-mobile', 'my-kiwi-modal-style-0');

        if(siteLabel == 'MT' || siteLabel == 'EO'){
            if(scrollTop == 0){
                scrollTop = document.body.getAttribute('size-data-top') ?? 0;
            }
            document.body.setAttribute('size-data-top', scrollTop);
        }else{
            document.body.style.top = -scrollTop + 'px';
        }
        openLock = false;
    }

    var closeLock = false;

    function sizeClose(){
        if(closeLock){
            return false;
        }
        closeLock = true;
        let scrollTop = 0;
        if(siteLabel == 'MT' || siteLabel == 'EO'){
            scrollTop = document.body.getAttribute('size-data-top');
        }else{
            scrollTop = document.body.style.top;
        }

        document.querySelector(domId).style.display = 'none';
        document.documentElement.classList.remove('my-kiwi-sizing-modal-visible');
        document.body.classList.remove('fixed-on-mobile', 'my-kiwi-modal-style-0');

        if (scrollTop) {
            const scrollPosition = Math.abs(parseInt(scrollTop)) || 0;
            window.scrollTo({
                top: scrollPosition,
                left: 0,
                behavior: 'instant' // 瞬间定位，无动画
            });
        }
        closeLock = false;
    }

    function getScrollTop() {
        // 现代浏览器
        if (window.pageYOffset !== undefined) {
            return window.pageYOffset;
        }

        // 移动端兼容
        if (document.scrollingElement) {
            return document.scrollingElement.scrollTop;
        }

        // 标准模式
        if (document.documentElement && document.documentElement.scrollTop) {
            return document.documentElement.scrollTop;
        }

        // 怪异模式
        if (document.body.scrollTop) {
            return document.body.scrollTop;
        }

        return 0;
    }

    function show(){

        document.body.insertBefore(document.querySelector(domId), document.body.firstChild);

        document.querySelector(domId + ' .modal-title-header').innerHTML = productTitle; //设置标题

        var isCountry = (sizeList.is_country == 1 && Array.isArray(sizeList.country));

        if(isCountry){
            currentCountry = sizeList.country[0];
        }
        //加载表格数据
        const tableBody = document.querySelector(domId + ' .my-ks-table > tbody');
        tableBody.innerHTML = '';
        // 1. 生成表头行
        addData(tableBody, sizeList.head, true);
        // 2. 生成数据行
        sizeList.body.forEach((data) => {
            addData(tableBody, data);
        });

        if(detail.length > 0){
            var individual = document.querySelector(domId + ' .my-ks-chart-individual');
            detail.forEach((data) => {
                if(data.type == 'img'){
                    var urlList = data.content.split(',');
                    for(var i = 0; i < urlList.length; i++){
                        individual.appendChild(getImageDom(urlList[i]));
                    }
                }else{
                    individual.appendChild(getHtmlDom(data.content));
                }
            });
        }

        // 右上角添加国家下拉（仅多国家时）
        if(isCountry) {
            var selectHtml = '<select id="size-country-switch-select">';
            sizeList.country.forEach(function(c){
                selectHtml += '<option value="'+c+'">'+c+'</option>';
            });
            selectHtml += '</select>';

            var table = document.querySelector(domId + ' .my-ks-table');
            if(table) {
                var theadRows = table.querySelector('.my-ks-table-header-row').querySelectorAll('td');
                theadRows[1].innerHTML = selectHtml;

                document.getElementById('size-country-switch-select').addEventListener('change', function(){
                    currentCountry = this.value;
                    renderCountryColumn();
                });
            }
        }

        setTimeout(function() {
            initEventListeners();
        }, 0);
    }

    // 确保事件监听器只绑定一次
    function initEventListeners() {
        // 移除已存在的事件监听器（如果有的话）
        const openContainer = document.querySelector('#product-size-chart-open-container');
        const closeBtn = document.querySelector('#product-size-chart-close');

        if (openContainer) {
            // 使用命名函数便于移除
            openContainer.removeEventListener('click', handleOpenClick);
            openContainer.addEventListener('click', handleOpenClick);
        }

        if (closeBtn) {
            closeBtn.removeEventListener('click', handleCloseClick);
            closeBtn.addEventListener('click', handleCloseClick);
        }
    }

    function handleOpenClick(e) {
        e.stopPropagation();
        sizeOpen();
    }

    function handleCloseClick(e) {
        e.stopPropagation();
        sizeClose();
    }

    // 渲染/切换国家列
    function renderCountryColumn() {
        // 更新每行国家列
        var trs = document.querySelectorAll(domId + ' .my-ks-table > tbody > tr');
        trs.forEach(function(tr, i){
            // 跳过表头
            if(i === 0) return;
            var tds = tr.querySelectorAll('td');
            if(tds.length > 1 && sizeList.country_value && sizeList.country_value[currentCountry]) {
                tds[1].textContent = sizeList.country_value[currentCountry][i-1] || '';
            }
        });
    }

    document.addEventListener('DOMContentLoaded', function() {
        const unitToggleLabels = document.querySelectorAll(domId + ' .my-ks-unit-toggle-label');
        unitToggleLabels.forEach((label) => {
            label.addEventListener('click', function() {
                const value = this.getAttribute('data-value');
                if(value == currentType){
                    return;
                }
                currentType = value;
                unitToggleLabels.forEach((label) => {
                    label.classList.remove('my-kiwi-active');
                });
                this.classList.add('my-kiwi-active');

                updateTableValues();
            })
        });

    })

    function addData(tableBody, data, isTitle = false){
        const title = data[0]; // 第一个元素是测量项名称
        const values = data.slice(1); // 剩余元素是尺寸数据

        const row = document.createElement('tr');
        var className = 'my-ks-table-row ';
        if(isTitle){
            className += 'my-ks-table-header-row';
        }else{
            className += 'my-ks-table-data-row';
        }
        row.className = className;

        // 添加测量项名称
        const titleCell = createTableCell(title, false, true);
        row.appendChild(titleCell);

        // 添加尺寸数据
        values.forEach((value, index) => {
            // 第二列为国家列
            if(sizeList.is_country == 1 && index === 0 && !isTitle) {
                value = sizeList.country_value[currentCountry][tableBody.children.length-1] || '';
            }
            const cell = createTableCell(value, !isTitle, false);
            row.appendChild(cell);
        });

        tableBody.appendChild(row);
    }

    // 创建表格单元格
    function createTableCell(value, isData = true, title = false) {
        const cell = document.createElement('td');
        cell.className = 'my-ks-table-cell ' + (title ? 'my-ks-table-header-cell' : '');
        cell.setAttribute('data-value-1', value);
        if(isData){
            //value/2.54 转换为英寸
            //如果value为5-10这种格式的
            if(value.indexOf('-') > -1){
                var valueArr = value.split('-');
                var min = (valueArr[0] / 2.54).toFixed(2);
                var max = (valueArr[1] / 2.54).toFixed(2);
                cell.setAttribute('data-value-0', min + '-' + max);
            }else{
                cell.setAttribute('data-value-0', (value / 2.54).toFixed(2));
            }
        }else{
            cell.setAttribute('data-value-0', value);
        }
        cell.setAttribute('data-header', title ? '1' : '0');
        cell.textContent = value;
        return cell;
    }

    // 根据当前单位更新表格
    function updateTableValues() {
        const dataRows = document.querySelectorAll(domId + ' .my-ks-table-data-row');
        dataRows.forEach((row) => {
            const cells = row.querySelectorAll('td');
            cells.forEach((cell, idx) => {
                // 跳过国家列
                if(sizeList.is_country == 1 && idx === 1) return;
                cell.textContent = cell.getAttribute('data-value-' + currentType);
            });
        });
    }

    //获得图片dom
    function getImageDom(url) {
        var html =  '<div class="my-ks-image" style="margin-top: 5px; margin-bottom: 5px; text-align: center">\n' +
            '                                    <img\n' +
            '                                            data-src="'+ url +'"\n' +
            '                                            class="Image--lazyLoaded"\n' +
            '                                            style="float:none; height: auto;width: auto; border-radius: 0px; -webkit-border-radius: 0px; -moz-border-radius: 0px;"\n' +
            '                                            src="'+ url +'"\n' +
            '                                    >\n' +
            '                                </div>';
        return htmlStringToElement(html);
    }

    function getHtmlDom(content) {
        var html =  '<div class="my-ks-html-content">' + content + '</div>';
        return htmlStringToElement(html);
    }

    //html转dom元素
    function htmlStringToElement(html) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.firstElementChild; // 获取第一个子元素
    }

    return {
        show: function() {
            show();
        }
    };
})();

try {
    myProductSizeChart.run.show();
} catch (error) {
    console.log('error:'+ error);
}